<template>
  <div>
    Fish
    <b-form-file v-model="file" class="mt-3" plain></b-form-file>
    <div class="mt-3">Selected file: {{ file ? file.name : "" }}</div>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
